import VueRouter from 'vue-router'
import Viewer from './views/Viewer'

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Viewer
    },
    {
      path: '/file/:file_id',
      name: 'file-view',
      component: Viewer
    },
    {
      path: '/file/:id/compare/:compare_ids',
      name: 'file-view-compare',
      component: Viewer
    },
    {
      path: '/file/:file_id/container/:container',
      name: 'file-container-view',
      component: Viewer
    },
    {
      path: '/file/:file_id/container/:container/patient/:patient',
      name: 'file-patients-view',
      component: Viewer
    },
    {
      path: '/file/:file_id/container/:container/patient/:patient/study/:study',
      name: 'file-study-view',
      component: Viewer
    },
    {
      path: '/file/:file_id/container/:container/patient/:patient/study/:study/series/:series',
      name: 'file-series-view',
      component: Viewer
    },
    // WADO
    {
      path: '/file/:file_id/wado',
      name: 'file-wado-view',
      component: Viewer
    },
    {
      path: '/file/:file_id/wado/study/:study',
      name: 'file-wado-study-view',
      component: Viewer
    },
    {
      path: '/file/:file_id/wado/study/:study/series/:series',
      name: 'file-wado-series-view',
      component: Viewer
    },
    // Remote
    {
      path: '/file/:file_id/remote',
      name: 'file-remote-view',
      component: Viewer
    },
    {
      path: '/file/:file_id/remote/patient/:patient',
      name: 'file-remote-patients-view',
      component: Viewer
    },
    {
      path: '/file/:file_id/remote/patient/:patient/study/:study',
      name: 'file-remote-study-view',
      component: Viewer
    },
    {
      path: '/file/:file_id/remote/patient/:patient/study/:study/series/:series',
      name: 'file-remote-series-view',
      component: Viewer
    },
    // JWT
    {
      path: '/remote',
      name: 'remote-view',
      component: Viewer
    },
    {
      path: '/remote/patient/:patient',
      name: 'remote-patients-view',
      component: Viewer
    },
    {
      path: '/remote/patient/:patient/study/:study',
      name: 'remote-study-view',
      component: Viewer
    },
    {
      path: '/remote/patient/:patient/study/:study/series/:series',
      name: 'remote-series-view',
      component: Viewer
    },
    {
      path: '/wado',
      name: 'wado-patients-view',
      component: Viewer
    },
    {
      path: '/wado/study/:study',
      name: 'wado-study-view',
      component: Viewer
    },
    {
      path: '/wado/study/:study/series/:series',
      name: 'wado-series-view',
      component: Viewer
    },
    {
      path: '/embed/:file_id',
      name: 'embed',
      component: Viewer
    },
    {
      path: '/embed/:file_id/container/:container',
      name: 'embed-file-container',
      component: Viewer
    },
    {
      path: '/embed/:file_id/container/:container/patient/:patient',
      name: 'embed-file-patient',
      component: Viewer
    },
    {
      path: '/embed/:file_id/container/:container/patient/:patient/study/:study',
      name: 'embed-file-study',
      component: Viewer
    },
    {
      path: '/embed/:file_id/container/:container/patient/:patient/study/:study/series/:series',
      name: 'embed-file-series',
      component: Viewer
    },
    // ML
    {
      path: '/v/:namespace/:sha/:file_id',
      name: 'public-file',
      component: Viewer
    },
    {
      path: '/v/:namespace/:sha/:file_id/container/:container',
      name: 'public-file-container',
      component: Viewer
    },
    {
      path: '/v/:namespace/:sha/:file_id/container/:container/patient/:patient',
      name: 'public-file-patient',
      component: Viewer
    },
    {
      path: '/v/:namespace/:sha/:file_id/container/:container/patient/:patient/study/:study',
      name: 'public-file-study',
      component: Viewer
    },
    {
      path: '/v/:namespace/:sha/:file_id/container/:container/patient/:patient/study/:study/series/:series',
      name: 'public-file-series',
      component: Viewer
    },
    {
      path: '/v/:namespace/:sha/:file_id/remote',
      name: 'public-file-remote-container',
      component: Viewer
    },
    {
      path: '/v/:namespace/:sha/:file_id/remote/patient/:patient',
      name: 'public-file-remote-patient',
      component: Viewer
    },
    {
      path: '/v/:namespace/:sha/:file_id/remote/patient/:patient/study/:study',
      name: 'public-file-remote-study',
      component: Viewer
    },
    {
      path: '/v/:namespace/:sha/:file_id/remote/patient/:patient/study/:study/series/:series',
      name: 'public-file-remote-series',
      component: Viewer
    },
    {
      path: '/v/:namespace/:sha/:id/compare/:compare_ids',
      name: 'public-file-compare',
      component: Viewer
    }
  ]
})

export default router
